import { FC, RefObject } from "react";
import { Box, Button } from "@mui/material";
import UploadFileLongPostSvg from "@/assets/svg/UploadFileLongPostSvg";
import RemoveImgArticle from "@/assets/svg/RemoveImgArticle";
import theme from "@/theme";

interface CoverImageUploaderProps {
  imagePreview: string | null;
  fileInputRef: RefObject<HTMLInputElement | null>;
  handleSelectImage: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleRemoveImage: () => void;
  editPost: any;
}

const UploadImage: FC<CoverImageUploaderProps> = ({
  imagePreview,
  fileInputRef,
  handleSelectImage,
  handleRemoveImage,
}) => {
  return !imagePreview ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        height: "4.625rem",
        border: "2px solid #F3F3F3C9",
        borderRadius: "0.75rem",
      }}
    >
      <Button
        onClick={() => fileInputRef.current?.click()}
        startIcon={<UploadFileLongPostSvg />}
        variant="text"
        sx={{
          textTransform: "none",
          color: theme.palette.custom.mainBlue,
          width: "100%",
          fontSize: "0.9375rem",
          fontWeight: 700,
        }}
      >
        Upload cover image
      </Button>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleSelectImage}
        hidden
        accept="image/*"
        style={{ display: "none" }}
      />
    </Box>
  ) : (
    <Box
      sx={{
        width: "100%",
        maxHeight: "520px",
        position: "relative",
        overflow: "hidden",
        borderRadius: "14px",
      }}
    >
      <img
        src={imagePreview}
        alt="post_image"
        style={{
          width: "100%",
          maxHeight: "520px",
          objectFit: "fill",
          display: "block",
        }}
      />
      <Button
        onClick={handleRemoveImage}
        sx={{
          padding: 0,
          minWidth: 0,
          position: "absolute",
          right: "16px",
          top: "14px",
          height: "38px",
          width: "38px",
          borderRadius: "50%",
          cursor: "pointer",
        }}
      >
        <RemoveImgArticle />
      </Button>
    </Box>
  );
};

export default UploadImage;
